import React from 'react';
import {
  computeCommission,
  formatCurrency,
  formatDate,
} from './utils';

export default function CommissionTable({
  rows,
  activeTab,
  selectedCollectionIds,
  pendingCollectionIds,
  allPendingSelected,
  isLoading,
  resolveCommissionRate,
  resolveRowStatus,
  onToggleRowSelection,
  onToggleAllPendingSelection,
  onOpenForm2307,
  onOpenTagPaid,
  onOpenCancel,
  canTagPaid,
  canCancel,
  canRelease,
}) {
  const colSpan = activeTab === 'standard' ? 18 : 17;

  return (
    <div className="dashboard-table-wrap">
      <table className="dashboard-table commissions-table">
        <thead>
          <tr>
            {activeTab === 'standard' ? (
              <th className="commissions-checkbox-cell">
                <input
                  type="checkbox"
                  className="commissions-checkbox"
                  checked={allPendingSelected}
                  onChange={onToggleAllPendingSelection}
                  disabled={pendingCollectionIds.length === 0 || !canRelease}
                />
              </th>
            ) : null}
            <th>Payment Date</th>
            <th>Transaction No.</th>
            <th>AR / SI No.</th>
            <th>Agent</th>
            <th>Client</th>
            <th>Product</th>
            <th>Branch</th>
            <th>Premium Paid</th>
            <th>Commission Rate</th>
            <th>12% VAT</th>
            <th>Net Commissionable</th>
            <th>Gross Commission</th>
            <th>10% WHT</th>
            <th>Net Commission</th>
            <th>Status</th>
            <th>Proof</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={colSpan} className="commissions-empty-row">
                {isLoading ? 'Loading commissions...' : 'No commission records found.'}
              </td>
            </tr>
          ) : rows.map((row) => {
            const rate = resolveCommissionRate(row);
            const calculations = computeCommission(row.premium_amount, rate);
            const status = typeof resolveRowStatus === 'function' ? resolveRowStatus(row) : 'Pending';
            const canMutate = status !== 'Released' && String(row.status || '') !== 'Cancelled';
            const isTaggedPaid = status === 'Paid';
            const payoutProofUrl = row.agent_payout?.proof_of_payment_url || null;
            const payoutProofName = row.agent_payout?.proof_of_payment_name || null;
            const isSelected = selectedCollectionIds.includes(Number(row.id));

            return (
              <tr key={row.row_key || `${row.id}-${row.agent_name || 'agent'}`}>
                {activeTab === 'standard' ? (
                  <td className="commissions-checkbox-cell">
                    <input
                      type="checkbox"
                      className="commissions-checkbox"
                      checked={isSelected}
                      onChange={() => onToggleRowSelection(row.id)}
                      disabled={!canMutate || !canRelease}
                    />
                  </td>
                ) : null}
                <td>{formatDate(row.payment_date)}</td>
                <td className="commissions-mono-cell">{row.transaction_no || '-'}</td>
                <td className="commissions-mono-cell">{row.ar_si_no || '-'}</td>
                <td>{row.agent_name || '-'}</td>
                <td>{row.client_name || '-'}</td>
                <td>{row.product || '-'}</td>
                <td>{row.branch || '-'}</td>
                <td className="commissions-number-cell">{formatCurrency(calculations.premium)}</td>
                <td className="commissions-rate-cell">
                  <span>{row.agent_position || '-'}</span>
                  <strong>{(rate * 100).toFixed(2)}%</strong>
                </td>
                <td className="commissions-number-cell">{formatCurrency(calculations.vat)}</td>
                <td className="commissions-number-cell">{formatCurrency(calculations.netCommissionable)}</td>
                <td className="commissions-number-cell">{formatCurrency(calculations.grossCommission)}</td>
                <td className="commissions-number-cell commissions-tax-cell">{formatCurrency(calculations.wtax)}</td>
                <td className="commissions-number-cell commissions-net-cell">{formatCurrency(calculations.netCommission)}</td>
                <td>
                  {activeTab === 'autodeduct' ? (
                    <span className="status-badge commissions-auto-badge">Auto Deduct</span>
                  ) : (
                    <span className={`status-badge ${status === 'Released' || status === 'Paid' ? 'status-active' : 'status-inactive'}`}>
                      {status}
                    </span>
                  )}
                </td>
                <td>
                  {payoutProofUrl ? (
                    <a href={payoutProofUrl} target="_blank" rel="noreferrer">
                      {payoutProofName || 'View'}
                    </a>
                  ) : '-'}
                </td>
                <td>
                  <div className="dashboard-actions">
                    <button
                      type="button"
                      className="profile-secondary-btn profile-secondary-btn-xs"
                      onClick={() => onOpenForm2307(row)}
                    >
                      View 2307
                    </button>
                    {activeTab === 'standard' && canMutate ? (
                      <>
                        {canTagPaid ? (
                          <button
                            type="button"
                            className="profile-secondary-btn profile-secondary-btn-xs"
                            onClick={() => onOpenTagPaid(row)}
                          >
                            {isTaggedPaid ? 'Edit Payment' : 'Tag Paid'}
                          </button>
                        ) : null}
                        {canCancel ? (
                          <button
                            type="button"
                            className="profile-danger-btn profile-danger-btn-xs"
                            onClick={() => onOpenCancel(row)}
                          >
                            Cancel
                          </button>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
